export const formatosFecha = [
  "DD/MM/YYYY",
  "D/M/YY",
  "DD/MM/YY",
  "D/M/YYYY",
  "DD-MM-YYYY",
  "D-M-YY",
  "DD-MM-YY",
  "D-M-YYYY",
  "YYYY/MM/DD",
  "YY/M/D",
  "YY/MM/DD",
  "YYYY/M/D",
  "YYYY-MM-DD",
  "YY-M-D",
  "YY-MM-DD",
  "YYYY-M-D",
];

// Mapeo de nombres de meses en español (abreviados y completos)
const mesesAbreviados = {
  1: "Ene", 2: "Feb", 3: "Mar", 4: "Abr", 5: "May", 6: "Jun",
  7: "Jul", 8: "Ago", 9: "Sep", 10: "Oct", 11: "Nov", 12: "Dic"
};

const mesesCompletos = {
  1: "Enero", 2: "Febrero", 3: "Marzo", 4: "Abril", 5: "Mayo", 6: "Junio",
  7: "Julio", 8: "Agosto", 9: "Septiembre", 10: "Octubre", 11: "Noviembre", 12: "Diciembre"
};

/**
 * Genera variantes de fecha con nombres de meses para buscar en texto OCR
 * @param {Date|string} fecha - La fecha a convertir
 * @returns {string[]} - Array con todas las variantes de la fecha
 */
export function generarFechasConNombreMes(fecha) {
  const date = new Date(fecha);
  const dia = date.getDate();
  const diaConCero = dia.toString().padStart(2, '0');
  const mes = date.getMonth() + 1;
  const año = date.getFullYear();
  const añoCorto = año.toString().slice(-2);

  const mesAbrev = mesesAbreviados[mes];
  const mesAbrevUpper = mesAbrev.toUpperCase(); // FEB, ENE, etc.
  const mesCompleto = mesesCompletos[mes];
  const mesCompletoUpper = mesCompleto.toUpperCase(); // FEBRERO, ENERO, etc.

  const variantes = [
    // Con mes abreviado y separadores (02-Feb-2026, 02/Feb/2026, 02 Feb 2026)
    `${diaConCero}-${mesAbrev}-${año}`,
    `${diaConCero}-${mesAbrevUpper}-${año}`,
    `${diaConCero}/${mesAbrev}/${año}`,
    `${diaConCero}/${mesAbrevUpper}/${año}`,
    `${diaConCero} ${mesAbrev} ${año}`,
    `${diaConCero} ${mesAbrevUpper} ${año}`,
    `${dia}-${mesAbrev}-${año}`,
    `${dia}-${mesAbrevUpper}-${año}`,
    `${dia}/${mesAbrev}/${año}`,
    `${dia}/${mesAbrevUpper}/${año}`,
    `${dia} ${mesAbrev} ${año}`,
    `${dia} ${mesAbrevUpper} ${año}`,
    // Con año corto
    `${diaConCero}-${mesAbrev}-${añoCorto}`,
    `${diaConCero}-${mesAbrevUpper}-${añoCorto}`,
    `${diaConCero}/${mesAbrev}/${añoCorto}`,
    `${diaConCero}/${mesAbrevUpper}/${añoCorto}`,
    `${dia}-${mesAbrev}-${añoCorto}`,
    `${dia}-${mesAbrevUpper}-${añoCorto}`,
    // Sin separadores (02Feb2026)
    `${dia}${mesAbrev}${año}`,
    `${dia}${mesAbrevUpper}${año}`,
    `${dia}${mesAbrev}${añoCorto}`,
    `${diaConCero}${mesAbrev}${año}`,
    `${diaConCero}${mesAbrevUpper}${año}`,
    `${diaConCero}${mesAbrev}${añoCorto}`,
    // Con "de" (02 de Feb de 2026)
    `${dia}de${mesAbrev}de${año}`,
    `${dia}de${mesAbrev}del${año}`,
    `${diaConCero}de${mesAbrev}de${año}`,
    `${diaConCero}de${mesAbrev}del${año}`,
    // Con mes completo y separadores
    `${diaConCero}-${mesCompleto}-${año}`,
    `${diaConCero}-${mesCompletoUpper}-${año}`,
    `${diaConCero}/${mesCompleto}/${año}`,
    `${diaConCero} ${mesCompleto} ${año}`,
    `${diaConCero} ${mesCompletoUpper} ${año}`,
    `${dia}-${mesCompleto}-${año}`,
    `${dia}/${mesCompleto}/${año}`,
    `${dia} ${mesCompleto} ${año}`,
    // Con mes completo sin separadores
    `${dia}${mesCompleto}${año}`,
    `${dia}${mesCompleto}${añoCorto}`,
    `${diaConCero}${mesCompleto}${año}`,
    `${diaConCero}${mesCompleto}${añoCorto}`,
    `${dia}de${mesCompleto}de${año}`,
    `${dia}de${mesCompleto}del${año}`,
    `${diaConCero}de${mesCompleto}de${año}`,
    `${diaConCero}de${mesCompleto}del${año}`,
  ];

  // Agregar variantes en minúsculas
  const variantesMinusculas = variantes.map(v => v.toLowerCase());

  return [...variantes, ...variantesMinusculas];
}

export function getDateStringYYYYMMDD(){
    const today = new Date();
    const fechaActual = today.toISOString().split("T")[0];
    return fechaActual;
}

export function getNewFormattedDate(){

    const now = new Date();

    // Obtener la diferencia en horas entre la zona horaria local (Argentina) y UTC
    const offset = -3; // Argentina está generalmente en UTC-3
    const localDate = new Date(now.getTime() + offset * 60 * 60 * 1000);

    // Formatear la fecha en formato ISO 8601 con el offset `+00:00`
    const formattedDate = localDate.toISOString().replace("Z", "+00:00");
    return  formattedDate
}